<template>
  <div class="mobile-footer-panel">
    <ProductNavRow :active="cockfightActive" @select-cockfight="$emit('select-cockfight')" />

    <div class="mobile-footer-panel__wallet-row">
      <div class="mobile-footer-panel__balance">
        <span class="mobile-footer-panel__balance-amount relative">
          {{ currencySymbol }}
          <animated-amount :value="balanceValue" :formatValue="formatAmount" :duration="500" />
          <Transition name="fade">
            <div v-if="futureDiff" class="mobile-footer-panel__future-diff">+ {{ userFutureDiff }}</div>
          </Transition>
        </span>
      </div>
      <div class="mobile-footer-panel__logo-slot">
        <Logo />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatAmount } from '@/utils/helpers';
import Logo from '@/components/logo.vue';
import AnimatedAmount from '@/components/animated-amount.vue';
import ProductNavRow from '@/components/tai-xiu/product-nav-row.vue';

export default {
  components: {
    AnimatedAmount,
    Logo,
    ProductNavRow,
  },
  props: {
    cockfightActive: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    formatAmount,
  }),
  computed: {
    ...mapGetters({
      balance: 'general/balance',
      futureDiff: 'general/futureDiff',
      member: 'general/member',
    }),
    userFutureDiff() {
      return formatAmount(this.futureDiff, 2);
    },
    currencySymbol() {
      return this.member.currencySymbol;
    },
    balanceValue() {
      return Number(this.balance) || 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-footer-panel {
  min-height: 66px;
  /*
   * Reserve the home-indicator inset so the panel's visual top edge stays at
   * 66px + inset -- the same offset the table bar and the closed dice tab are
   * anchored to, which keeps them flush instead of floating above a gap.
   * v2.1: arena tabs + menu (38), then balance + logo (28).
   */
  padding: 0 10px env(safe-area-inset-bottom, 0px);
  box-sizing: border-box;
  background-color: $ga-rail-bg;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-top: 1px solid $ga-border-default;
  box-shadow: none;
}

.mobile-footer-panel__wallet-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  height: 28px;
  min-height: 28px;
  padding-bottom: 4px;
  box-sizing: border-box;
}

.mobile-footer-panel__balance {
  min-width: 0;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  gap: 6px;
}

.mobile-footer-panel__balance-amount {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: $ga-gold-300;
  font-size: 15px;
  font-weight: 700;
  line-height: 1;
  font-feature-settings: 'tnum' on, 'lnum' on;
}

.mobile-footer-panel__future-diff {
  position: absolute;
  bottom: 100%;
  right: 0;
  font-size: 10px;
  font-weight: 600;
  color: #ffefcc;
}

/*
 * Flush with the panel's right padding, the same place the open menu's footer
 * (menus/menu-footer.vue) puts it, so the logo does not jump when the menu
 * opens or closes.
 */
.mobile-footer-panel__logo-slot {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

::v-deep .logo {
  flex: 0 0 auto;
  display: block;
  width: auto;
  height: 9px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s ease;
}

.fade-enter-from {
  opacity: 0;
  top: 100%;
}

.fade-leave-to {
  opacity: 0;
  top: 0;
}

@media screen and (max-width: 390px) {
  .mobile-footer-panel {
    padding-right: 10px;
    padding-left: 10px;
  }
}
</style>
